module.exports = __webpack_public_path__ + "static/media/chemical1.41ad0325.jpg";